import lazyLoading from "./lazyLoading";

export default {
  name: "staff",
  meta: {
    icon: "fa-users",
    expanded: false,
    label: "Staff",
    permissions: "list staffs"
  },

  children: [
    {
      name: "list-staff",
      path: "/admin/staff/liste",
      meta: {
        title: "Membres du Staff",
        label: "Liste",
        //isAdminStaff: true,
        permissions: "list staffs"
      },
      component: lazyLoading("staff/index")
    },
    {
      name: "list-roles",
      path: "/admin/staff/roles",
      meta: {
        title: "Roles et permissions",
        label: "Roles",
        isAdminStaff: true
      },
      component: lazyLoading("roles/index")
    }
  ]
};
